import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.31_db0@0.3.2_e_00cb76e3a1849923fa6bc006d3397733/node_modules/nuxt/dist/pages/runtime/validate.js";
import catch_45dynamic_45global from "/app/middleware/catch-dynamic.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.31_db0@0.3.2_e_00cb76e3a1849923fa6bc006d3397733/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  catch_45dynamic_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  "check-page-access": () => import("/app/middleware/check_page_access.js"),
  "sidebase-auth": () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_@netlify+blobs@8.2.0_magicast@0.3.5_next-auth@4.21.1_next@13_87fdda1e559aa1771b6103c4d034b170/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}